"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isDefined(value) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value !== undefined && value !== null;
}
exports.isDefined = isDefined;
//# sourceMappingURL=isDefined.js.map